
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M51.42 42.18l.08-7.86H21.9M51.5 34.12a14.8 14.8 0 10-29.6 0"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M32.95 19.92v-6.7h7.5v6.7M14.72 41.97h43.2v16.76h-43.2zM7.53 9.44v-4a4.28 4.28 0 118.56 0v4"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M14.36 58.73H2.08V18.67h19.47v24.26"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M4.86 18.76V9.39h13.91v9.37M47.1 59.25a10.71 10.71 0 00-21.41 0"}})])
          )
        }
      }
    